import { FC } from 'react'
import Machine from '../machine/machine'
import { machineHasStampRoller, RecordWithStampRoller } from '../../../helpers/machine-has-stamp-roller'

interface MachineBrandWrapperProps {
    record?: RecordWithStampRoller
}

const MachineBrandWrapper: FC<MachineBrandWrapperProps> = ({ record }) => {
    const disabledMachine = (machine: Parameters<typeof machineHasStampRoller>[0]) =>
        !machineHasStampRoller(machine, record)

    return (
        <Machine
            name={['machine', 'set']}
            filters={{ machine_type: { name: { $eq: 'platen' } } }}
            unique
            noStyle
            autoFocus
            disabledMachine={disabledMachine}
            populate={{
                rollers: true,
            }}
        />
    )
}

export default MachineBrandWrapper

